import { ComponentType, PropsWithChildren, ReactNode } from "react"

export type OptionProps = {
  // If dropdown is configured to support multi selection,
  // it's possible to configure checkbox indeterminate property
  isIndeterminate?: boolean
  // Is option selected or not is defined from dropdown value.
  // Sometimes it's necessary explicitly set option in UI as selected
  overrideIsSelected?: boolean
  value: DropdownValue
  label?: string
  disabled?: boolean
}

export type OptionPropsWithChildren = PropsWithChildren<OptionProps>

export type DropdownValue = any

export type DropdownTexts = {
  cancel: string
  done: string
}

export type CommonDropdownProps = {
  className?: string
  isMobileView?: boolean
  // text that's rendered in collapsed input is generated, based on dropdown value.
  // overrideDisplayText - allows explicitly set this text.
  overrideDisplayText?: string
  placeholder?: string
}

export type SingleDropdownProps = CommonDropdownProps & {
  isMultiple?: false
  onChange?(value: DropdownValue): void
  onChangeSelected?(value: DropdownValue): void
  value?: DropdownValue
}

export type MultipleDropdownProps = CommonDropdownProps & {
  texts: DropdownTexts
  isMultiple?: true
  onChange?(value: DropdownValue[]): void
  onChangeSelected?(value: DropdownValue[]): void
  value?: DropdownValue[]
}

export type DropdownProps = SingleDropdownProps | MultipleDropdownProps

export type DropdownChildren = ReactNode

export type DropdownPropsWithChildren = DropdownProps & {
  children: DropdownChildren
}

export type DropdownStaticProps = {
  Option: ComponentType<OptionPropsWithChildren>
}

export const isMultipleDropdown = (
  component: SingleDropdownProps | MultipleDropdownProps,
): component is MultipleDropdownProps => {
  return (component as MultipleDropdownProps).texts !== undefined
}
